module.exports = {
  message: {
    service_desc: '通过此工具来转换 COS 代币的格式，包括<strong>主网原生 COS、ERC-20、BEP-20</strong>',
    choose_token_type: '代币转换方向',
    fee_tips: '',
    token_type_erc20_to_bep2: 'ERC-20 => BEP2',
    token_type_erc20_to_native: 'ERC-20 => 主网原生 COS',
    token_type_bep2_to_erc20: 'BEP2 => ERC-20',
    token_type_bep2_to_native: 'BEP2 => 主网原生 COS',
    token_type_native_to_erc20: '主网原生 COS => ERC-20',
    token_type_native_to_bep2: '主网原生 COS => BEP2',
    token_type_bep20_to_native: 'BEP-20 => 主网原生 COS',
    token_type_native_to_bep20: '主网原生 COS => BEP-20',
    enter_address: '转换目的账号/地址',
    enter_exchange_memo: 'Memo（监测到目的地址为交易所，请填入交易所提供的 Memo 以确保顺利接收 COS 代币）',
    create_account_tips: '没有账号吗？马上创建',
    next_btn: '下一步',
    start_over_btn: '重新开始',
    ready_to_swap: '准备好进行代币转换',
    transfer_prefix: '将你的 {token} 转账到',
    address: '账号/地址',
    memo: 'MEMO',
    auto_swap_desc: '请确保转账到正确的账号/地址，代币转换工具收到转账后，' +
      '会将相应的代币数量转入指定的目的钱包。<strong>（此过程约需五至三十分钟）</strong>',
    auto_swap_desc_memo: '请确保转账到正确的账号/地址并附带上述的 MEMO，代币转换工具收到转账后，' +
      '会将相应的代币数量转入指定的目的钱包。<strong>（此过程约需五至三十分钟）</strong>',
    main_net_address: 'Contentos 主网账号',
    bep2_address: 'BEP2 钱包地址',
    erc20_address: 'ERC-20 钱包地址',
    bep20_address: 'BEP-20 钱包地址',
    main_net_token: 'COS MainNet',
    bep2_token: 'BEP2 COS',
    erc20_token: 'ERC-20 COS',
    bep20_token: 'BEP-20 COS',
    ok: '确定',
    Cancel: '取消',
    tips: '提示',
    enter_address_tips: '请输入正确的地址',
    enter_exChange_memo_tips: '请输入正确的 Memo',
    swap_address_invalid: '此地址不符合规范',
    swap_address_not_exit: '此账号不存在',
    swap_type_invalid: '无效的代币转换方向',
    swap_system_error: '系统错误，请稍后再试',
    swap_unknown_error: '发生未知错误，请稍后再试',
    swap_memo_invalid: 'Memo不符合规范',
    invalid_bnb_exChange_memo_tips: '币安交易所Memo必须是数字',
    paste_warning: '将地址贴上时，请确认与复制的内容相符',
    fee_notice: '请注意：每笔{token}转换将收取{fee} COS手续费用于帐户转帐的gas费用，不足{fee} COS的转换将不会被处理。',
    fee_subject_to_change: '手续费根据市场行情浮动，不另行通知。',
    view_status: '浏览目前转换状况',
    prev_step: '上一步',
    go_back: '返回',
    transfer_prefix_before: '将你的',
    transfer_prefix_after: '转账到',
    copy_memo: '复制 MEMO',
    copy_address: '复制地址',
    copy_success: '复制成功',
    memo_warning: '请注意：转账时请务必附上正确 MEMO。系统将依实际入账数量完成转换并转回你填写的地址，请勿省略 MEMO。',
    col_time: '时间',
    col_target_format: '目标格式',
    col_target_account: '目标账户',
    col_amount: '汇入金额',
    col_status: '状态',
    loading: '加载中\u2026',
    no_data: '暂无数据',
    next_update_hint: '数据将于 {time} 后更新',
    status_done: '已完成',
    status_pending: '处理中',
    panel_title_status: '目前转换状况',
    panel_title_step1: '币种转换工具',
    panel_title_step2: '准备好进行代币转换',
    panel_subtitle_status: '选择来源代币格式以查看转换纪录',
    source_network: '来源代币格式',
    conversion_record: '转换记录',
    new_label: '新'
  }
}
